import { createClient, type SupabaseClient } from '@supabase/supabase-js';
import { env } from '../config/env.ts';
import { authStorage } from './platform.ts';

let client: SupabaseClient | null = null;

/** The single Supabase client. Throws if configuration is missing (never silently mocks). */
export function supabase(): SupabaseClient {
  if (!env.configured) throw new Error('Supabase is not configured');
  client ??= createClient(env.supabaseUrl, env.supabaseAnonKey, {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
      flowType: 'implicit',
      storage: authStorage,
      storageKey: 'mt-auth',
    },
    global: { headers: { 'x-client-info': 'music-theory-web' } },
  });
  return client;
}
